(function () {

  var PRELOAD_CFG = {
    blinkDurationMs: 1200,
    cyclesAfterLoad: 2,
    safetyTimeout: 10000
  };

  var preloaderEl;
  var safetyTimer;

  function getPreloader() {
    preloaderEl = document.querySelector('[data-preloader]');
  }

  function showPreloader() {
    getPreloader();
    if (!preloaderEl) return;

    document.documentElement.classList.add('preloader-active');
    preloaderEl.classList.remove('hidden');

    clearTimeout(safetyTimer);
    safetyTimer = setTimeout(hidePreloader, PRELOAD_CFG.safetyTimeout);
  }

  function hidePreloader() {
    getPreloader();
    if (!preloaderEl) return;

    document.documentElement.classList.remove('preloader-active');
    preloaderEl.classList.add('hidden');
  }

  function handleInitialLoad() {
    var wait = PRELOAD_CFG.blinkDurationMs * PRELOAD_CFG.cyclesAfterLoad;
    setTimeout(hidePreloader, wait);
  }

  function interceptLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;

      var href = a.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      if (a.target === '_blank') return;
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;

      e.preventDefault();

      showPreloader();

      setTimeout(function () {
        window.location.href = href;
      }, 80);

    }, true);
  }

  function start() {
    getPreloader();
    interceptLinks();

    if (document.readyState === 'complete') {
      handleInitialLoad();
    } else {
      window.addEventListener('load', handleInitialLoad);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

})();
